exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-close[data-v-6be53474]{color:var(--dialogCloseBg)}", ""]);

// exports
